import '.fo{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.fp{padding-left:1.5rem;}.ssr-plugin'
import '.fq{margin:1rem 0;}.ssr-plugin'
import '.fr{color:var(--gray-700);}.ssr-plugin'
import '.fs{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="fo fp fq fr fs"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
